module.exports = __webpack_public_path__ + "img/Gem-Lane-contact-img19.68eaf540.jpg";